<template>
<div class="nearby-infrastructure">
	<ul>
		<li v-for="(item, index) in itemList" :key="index"
			@click="toggle(item)"
		>
			<span v-if="item.status" class="active">
				{{ item.name }}
			</span>
			<span v-else>
				{{ item.name }}
			</span>
		</li>
	</ul>
</div>
</template>

<script>

export default {
	data: () => ({
		itemList: [
			{name: 'Airport', value: 'airport', status: false},
			{name: 'Bus Links', value: 'bus_station', status: false},
			{name: 'Governmental services', value: 'government', status: false},
			{name: 'Hospitals', value: 'hospital', status: false},
			{name: 'Ports', value: 'port', status: false},
			{name: 'Rail Links', value: 'rail_station', status: false},
			{name: 'Schools', value: 'school', status: false},
			{name: 'Tourist attractions', value: 'attraction', status: false},
		]
	}),
	methods: {
		toggle(item) {
			item.status = !item.status
			let points = document.querySelectorAll('.point-type-' + item.value)
			Array.from(points).map(element => {
				element.style.display = item.status ? 'block' : 'none'
			})
			let popupList = document.getElementsByClassName('point-popup')
			if(popupList.length > 0) {
				Array.from(popupList).map(element => {
					element.classList.remove('active')
				})
			}
		}
	}
}
</script>

<style lang="scss">
.nearby-infrastructure {
	display: inline-table;
	width: 268px;

	ul {
		background: none;
		margin: 0;
		list-style: none;
		float: left;
		width: 100%;
		padding: 0;

		span {
			color: #999999;
			border: 1px solid #8a8c91;
			display: inline-block;
			padding: 5px 10px;
			border-radius: 15px;
			margin: 0px 5px 7px 0px;
			user-select: none;
			cursor: pointer;
			float: left;
			text-transform: uppercase;
			font-size: 10px;
		}

		span.active {
			background: #fff;
			border-color: #fff;
			color: #3b9fcf;
		}
		li:last-child span {
			margin: 0;
		}
	}
}
</style>
